import { Link } from "react-router-dom";
import { BrandMark } from "./Nav";
import { openCookieSettings } from "@/lib/consent";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 py-12" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row items-start md:items-center justify-between gap-8">
        <div>
          <BrandMark small />
          <p className="mt-3 text-xs text-slate-500 max-w-sm">
            Offres packagées autour de l'Agilité — un partenariat ASAP Technologies × Reqen Consulting.
          </p>
        </div>
        <div className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-slate-400">
          <a href="https://asaptech.fr" target="_blank" rel="noopener noreferrer" className="hover:text-teal-300 transition-colors" data-testid="footer-asap-link">asaptech.fr</a>
          <a href="https://www.reqen.fr" target="_blank" rel="noopener noreferrer" className="hover:text-teal-300 transition-colors" data-testid="footer-reqen-link">reqen.fr</a>
          <Link to="/agilite" className="hover:text-teal-300 transition-colors" data-testid="footer-agilite-link">L'Agilité</Link>
          <Link to="/quizz" className="hover:text-teal-300 transition-colors" data-testid="footer-quizz-link">Quiz</Link>
          <Link to="/flashdiag" className="hover:text-teal-300 transition-colors" data-testid="footer-flashdiag-link">FlashDiag</Link>
          <Link to="/livre-blanc" className="hover:text-teal-300 transition-colors" data-testid="footer-whitepaper-link">Livre blanc</Link>
          <Link to="/confidentialite" className="hover:text-teal-300 transition-colors" data-testid="footer-privacy-link">Confidentialité</Link>
          <Link to="/mentions-legales" className="hover:text-teal-300 transition-colors" data-testid="footer-legal-link">Mentions légales</Link>
          <button onClick={openCookieSettings} className="hover:text-teal-300 transition-colors text-left" data-testid="footer-cookie-settings-link">Gérer les cookies</button>
          <Link to="/admin" className="hover:text-teal-300 transition-colors" data-testid="footer-admin-link">Administration</Link>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-8 pt-6 border-t border-white/5 text-[11px] text-slate-600 font-mono2">
        © {new Date().getFullYear()} ASAP Technologies × Reqen — Tous droits réservés.
      </div>
    </footer>
  );
}
